import type { TFunction } from 'i18next'

import { INTERNAL_INCONSISTENCY_SWATCH_STYLE } from '~/components/planSubmit/PlanTable'
import type { PreviousDiffBarExtraItem } from '~/components/planSubmit/PreviousDiffBar'
import type { InternalInconsistencyView } from '~/pages/ProcurementPlanDetail/models/internalInconsistency'

/**
 * 計画内不整合の凡例項目 (AC-PPD-024 / 025)。該当のコマがある項目だけ返す。
 * スウォッチは共有 PlanTable の強調セルと同じ定義。
 */
export function internalInconsistencyLegendItems(
  view: InternalInconsistencyView | undefined,
  t: TFunction,
): PreviousDiffBarExtraItem[] {
  if (view === undefined) return []
  const items: PreviousDiffBarExtraItem[] = []
  if (view.balanceRows.size > 0) {
    items.push({
      key: 'internal-balance',
      label: t('page:procurementPlanDetail.internalInconsistency.balanceLabel'),
      swatchStyle: INTERNAL_INCONSISTENCY_SWATCH_STYLE,
    })
  }
  if (view.retailerGaps.size > 0) {
    items.push({
      key: 'internal-retailer',
      label: t(
        'page:procurementPlanDetail.internalInconsistency.retailerLabel',
      ),
      swatchStyle: INTERNAL_INCONSISTENCY_SWATCH_STYLE,
    })
  }
  return items
}
